import type { GetTagTypeByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetTagTypeByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetTagTypeByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetTagTypeByIdArgs = {
  id: string;
};

export const useGetTagTypeById = createQueryHook<
  UseGetTagTypeByIdArgs,
  GetTagTypeByIdResponseRow[],
  GetTagTypeByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.tag.tagTypeById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ tag_type: data }),
  graphqlDocument: GetTagTypeByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
